/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import Map from 'scripts/models/base/map';
import template from './drawer.stache';

Component.extend({
    tag: 'history-scoring-drawer',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            isDataAvailable: {
                type: 'boolean',
                get() {
                    return (
                        this.attr('data.rounds.0.holes') &&
                        this.attr('data.rounds.0.holes').length > 0
                    );
                },
            },
            round: {
                type: 'number',
                value: 1,
            },
            data: {
                Type: Map,
                Value: Map,
            },
        },
    },
    events: {
        '.js-drawer-close click'($el) {
            this.viewModel.dispatch({ type: 'onClose' });
        },
    },
});
